// nodeos e Hyperion devuelven las horas en UTC sin la "Z" final
// ("2026-10-20T16:06:22.000"). Sin ella, Date las interpreta como hora local.
export const parseChainTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);
  const s = String(value);
  return new Date(/(Z|[+-]\d\d:?\d\d)$/.test(s) ? s : `${s}Z`);
};

// "just now", "5m ago", "2h ago", "3d ago" o la fecha
export const formatRelativeTime = (value, now = Date.now()) => {
  const date = parseChainTime(value);
  if (!date || Number.isNaN(date.getTime())) return '';
  const diffMin = Math.floor((now - date.getTime()) / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}h ago`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 30) return `${diffD}d ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatChainDate = (value) => {
  const date = parseChainTime(value);
  return date && !Number.isNaN(date.getTime()) ? date.toLocaleString() : 'Unknown';
};
